import React, { useEffect } from "react";

const TeamShell = ({ children }) => {
  useEffect(() => {
    document.body.classList.add("team-page");
    return () => document.body.classList.remove("team-page");
  }, []);

  return (
    <div className="team-shell">
      <main className="team-main">{children}</main>
    </div>
  );
};

export default TeamShell;
